<app-organization-groups [organization]="organization"></app-organization-groups>
